import { keepPreviousData } from "@tanstack/react-query"

import { api } from "~/utils/api"

export function useAllocationSalesMap(skuIds: string[]) {
  return api.allocation.getAllocationSalesMap.useQuery(
    { skuIds },
    { enabled: skuIds.length > 0, placeholderData: keepPreviousData },
  )
}
